import { useEffect, useState } from "react";
import { getBetRecords, deleteBetRecord } from "../../api/betsApi";

const BetsTable = (props) => {
    const [betRecords, setBetRecords] = useState(null);

    useEffect(() => {
        const fetchBets = async () => {
            try {
                const result = await getBetRecords(props.betName, props.page);
                setBetRecords(result?.data?.records[0] ? result?.data?.records : null);
                props.setPagination(15,result?.data?.count);
            } catch (error) {
                alert('Error al obtener los registros');
            } finally {
            }
        };
        fetchBets();
    }, [props]);

    const handleDeleteClick = async (index) => {
        try {
            await deleteBetRecord(props.betName, betRecords[index]['_id']);
            alert('Se eliminó de forma correcta el registro');
            window.location.reload();
        } catch (error) {
            alert('Error al eliminar el registro');
        } finally {
        }
    };

    return (
        <table class="table table-bordered table-striped">
            <thead class="table-dark">
                <tr>
                    {betRecords ? Object.keys(betRecords[0])?.map((key, index) => (index > 0 ? <th key={index}>{key}</th> : '')) : ''}
                    <th>delete</th>
                </tr>

            </thead>
            <tbody id="table-body">
                {betRecords?.map((betRecord, index) => (<tr key={index}>
                    {betRecord ? Object.values(betRecord)?.map((value, index) => (index > 0 ?
                        <td key={index}>
                            {Array.isArray(value) ? value.join('-') : value}
                        </td>
                        : '')
                    )
                        : ''}
                    <td>
                        <button onClick={() => handleDeleteClick(index)}>
                            ❌
                        </button>
                    </td>
                </tr>))}
            </tbody>
        </table>)
};

export default BetsTable;